import React, { PropTypes } from 'react';
import styled from 'styled-components';

import Breakpoint from '../../utils/breakpoints';
import Profile from '../../components/common/Profile';

const DefaultHeader = styled.header`
  justify-content: space-between;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${props => props.theme.color.white};
  z-index: 100;
  align-items: center;
  height: 52px;
  padding: 0 0 0 76px;
`;

const Offset = styled.div`
  position: relative;
  height: 56px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

class FbtHeader extends React.Component {
  homeClick = () => this.context.router.push(this.props.homeRoute);

  render() {
    return (
      <Breakpoint name="desktop">
        <Offset />
        <DefaultHeader>
          <p />
          <RightSection>
            <Profile />
          </RightSection>
        </DefaultHeader>
      </Breakpoint>
    );
  }
}

FbtHeader.contextTypes = {
  router: PropTypes.object
};

FbtHeader.propTypes = {
  homeRoute: PropTypes.string
};

FbtHeader.defaultProps = {
  homeRoute: '/'
};

export default FbtHeader;



// WEBPACK FOOTER //
// ./src/layouts/fbt/FbtHeader.js